import * as Yup from "yup";

const autoSequenciaSerieValidator = Yup.object().shape({
  serie: Yup.number().required("Série"),
  sequencia: Yup.number().required("Sequencia"),
});

export default autoSequenciaSerieValidator;
